import elementLocale from 'element-ui/lib/locale/lang/en'
export default {
  floorplanEvaluation: {
    entry: "間取り評価",
    aiResultOnly: "このプロジェクトで最後に成功した AI 建築設計結果を評価します。画面上の変更は、保存の有無にかかわらず評価に含まれません。",
    running: "間取りを評価中／結果を読み込み中",
    previousVersion: "以前の AI 建築設計結果に対する評価、または結果のバージョンを確認できない評価です。",
    total: "総合点",
    normalized: "100点換算",
    objective: "客観評価",
    subjective: "主観評価",
    details: "評価の詳細",
    empty: "完了した評価はありません",
    refresh: "結果を更新",
    start: "評価を開始",
    failed: "間取り評価に失敗しました。再試行してください。",
    OBJ_01: "部屋の種類と数",
    OBJ_03: "MyBox 経験寸法への適合",
    OBJ_06: "隣接階の階段位置の一致",
    OBJ_07: "主要居室の外壁接触可能性",
    functional_zoning: "機能分区",
    circulation_organization: "動線計画",
    privacy: "プライバシー",
    spatial_comfort: "空間の快適性"
  },
  common: {
    appName: 'MH House',
    home: 'ホーム',
    login: 'ログイン',
    workspace: 'ワークスペース',
    logout: 'ログアウト',
    notFound: 'ページが見つかりません',
    backHome: 'ホームに戻る',
    cancel: 'キャンセル',
    confirm: '確認',
    apply: '適用',
    close: '閉じる',
    all: 'すべて',
    user: 'ユーザー',
    updated: '更新',
    project: 'プロジェクト'
  },
  nav: {
    wallet: 'ウォレット',
    changePassword: 'パスワード変更',
    titles: {
      projectsStructure: '構造プロジェクト',
      houseDesign: 'プロジェクト詳細',
      architecturePlan: '建築平面設計',
      structureDesign: '構造設計',
      structureCalculation: '構造計算',
      designReport: '設計レポート'
    }
  },
  home: {
    title: 'MH House WebUI',
    subtitle: '新規プロジェクト向けのクリーンなフロントエンド基盤です。',
    openWorkspace: 'ワークスペースを開く'
  },
  login: {
    title: 'ログイン',
    username: 'ユーザー名',
    password: 'パスワード',
    submit: 'ログイン',
    placeholder: 'ログイン API はプレースホルダーです。バックエンド確定後に置き換えてください。'
  },
  workspace: {
    title: 'ワークスペース',
    subtitle: '保護されたルートのプレースホルダーページです。'
  },
  projects: {
    searchPlaceholder: 'プロジェクト名を入力',
    empty: 'プロジェクトがありません',
    fetchFailed: 'プロジェクト一覧の取得に失敗しました',
    missingIdempotencyKey: 'プロジェクトに冪等キーがないため詳細を開けません',
    projectFallback: 'プロジェクト {id}',
    newProject: '新規プロジェクト',
    createDialogTitle: '新規プロジェクト',
    createDialogPlaceholder: 'プロジェクト名を入力してください',
    createNameRequired: 'プロジェクト名を入力してください',
    createFailed: 'プロジェクトの作成に失敗しました',
    createConfirm: '作成',
    manageProjects: 'プロジェクト管理',
    exitManage: '管理を終了',
    deleteSelected: '削除（{count}）',
    deleteConfirmTitle: 'プロジェクトの削除',
    deleteConfirmMessage: '選択した {count} 件のプロジェクトを削除しますか？この操作は取り消せません。',
    deleteConfirmButton: '削除',
    deleteSuccess: '{count} 件のプロジェクトを削除しました',
    deleteFailed: 'プロジェクトの削除に失敗しました'
  },
  houseDesign: {
    backToProjects: 'プロジェクトに戻る',
    pageTitle: 'プロジェクト詳細',
    pageTitleWithKey: 'プロジェクト詳細 - {key}',
    idempotencyKey: '冪等キー：{key}',
    missingKey: 'プロジェクトの冪等キーがありません。一覧から再度入ってください。',
    progressTitle: 'プロジェクト進捗',
    enterStepTitle: 'ステップに入る',
    enterStep: '{step}に入る',
    stepStatus: {
      completed: '完了',
      current: '現在のステップ',
      pending: '未着手'
    },
    steps: {
      architecturePlan: '建築平面設計',
      structureDesign: '構造設計',
      structureCalculation: '構造計算',
      designReport: '設計レポート'
    }
  },
  constraints: {
    back: 'プロジェクトに戻る',
    title: 'まずは建物の予算と間口を\n教えていただけますか',
    budget: {
      title: '予算'
    },
    frontage: {
      title: '間口',
      meters: '約 {meters} m'
    },
    recommendFailed: 'おすすめ商品を取得できませんでした。しばらくしてから再度お試しください',
    next: '次へ'
  },
  structureDesign: {
    generating: '生成中...',
    back: '戻る',
    title: '一戸建てAI設計',
    subtitle: 'デザインエディター · {name}',
    undo: '元に戻す',
    redo: 'やり直す',
    save: '保存',
    saveToStorage: '保存',
    exportToFile: 'ファイルへ出力',
    exportProjectJson: 'プロジェクト JSON を出力',
    exportCadJson: 'CAD JSON を出力',
    cadExport: {
      warningTitle: 'CAD 引き渡しの検証警告',
      warningMessage: 'CAD JSON に検証警告があります。完全には検証されていませんが、出力は続行できます。',
      continue: 'このまま出力',
      fatal: '平面図に無効な CAD ジオメトリがあるため出力できません。',
      failed: 'CAD JSON の出力に失敗しました。もう一度お試しください。',
      exported: 'CAD JSON を出力しました：{fileName}',
      annotationsSaveFailed: '寸法注記は出力されましたが、現在のプロジェクトには保存できませんでした。',
      issueCategories: {
        geometry: 'ジオメトリ検証の警告（{code}）',
        annotations: '注記検証の警告（{code}）',
        structure: 'AI 構造検証の警告（{code}）'
      }
    },
    load: '読み込み',
    project: 'プロジェクト',
    tools: 'ツール',
    select: '選択',
    sampleRoom: 'サンプルルーム',
    catalog: 'カタログ',
    searchCatalog: 'カタログを検索',
    designAssetRoomFilter: '部屋',
    designAssetStyleFilter: 'スタイル',
    designAssetRooms: {
      kitchen: 'キッチン',
      bathroom: '浴室',
      washroom: '洗面室',
      outdoor: '屋外',
      'living-dining': 'リビング・ダイニング',
      'master-bedroom': '主寝室',
      'kids-room': '子供部屋'
    },
    designAssetStyles: {
      'white-model': 'ホワイトモデル',
      natural: 'ナチュラル',
      'simple-modern': 'シンプルモダン',
      japandi: 'ジャパンディ',
      vintage: 'ヴィンテージ'
    },
    catalogFilterEmpty: '一致する素材が見つかりません',
    catalogFilterClear: '絞り込みをクリア',
    catalogFilterLoading: '絞り込み中…',
    catalogFilterBack: 'カテゴリ一覧に戻る',
    catalogFilterToggle: '絞り込みを開閉',
    properties: 'プロパティ',
    settings: '設定',
    projectConfiguration: 'プロジェクト設定',
    aiDesign: 'AI 設計パラメータ',
    generate: '設計を生成',
    view2d: '2D 表示',
    view3d: '3D 表示',
    switchTo3d: 'クリックでメイン画面を 3D に切り替え',
    switchTo2d: 'クリックでメイン画面を 2D に切り替え',
    zoomIn: '拡大',
    zoomOut: '縮小',
    fitView: 'キャンバスに合わせる',
    openCatalog: 'カタログを開く',
    export: 'エクスポート',
    exportChooseFormat: 'エクスポート形式を選択',
    import: 'インポート',
    developing: '開発中',
    catalogTitle: '要素カタログ',
    catalogHint: '要素を選択し、2D キャンバスをクリックして配置します',
    catalogAvailable: '利用可能な要素 {count} 件',
    catalogEmptyTitle: '一致する要素がありません',
    catalogEmptyHint: 'カテゴリや検索キーワードを変更してください',
    catalogFooter: 'カタログ / {category}',
    clearSearch: '検索をクリア',
    inspectorDeveloping: 'この機能は開発中です',
    selectionSummary: '{count} 件の要素を選択中',
    emptyState: '要素を選択するかカタログから選び、キャンバスで編集してください。',
    editorToolbar: {
      label: 'エディタコマンド',
      file: 'ファイル',
      clear: 'クリア',
      ai: 'AI',
      pdf: 'PDF出力',
      html: 'HTML出力',
      share: '共有',
      clearConfirmTitle: 'プランをクリア',
      clearConfirmMessage: '現在のプラン内容をクリアします。続行しますか？',
      placeholderNotice: 'この機能は後続モジュールで接続されます。現在はプレースホルダーです。'
    },
    clearScene: {
      success: 'プランをクリアしました',
      failed: 'プランのクリアに失敗しました。もう一度お試しください。'
    },
    drawingUnderlay: {
      title: '下絵',
      show: '下絵を表示',
      hide: '下絵を隠す',
      opacity: '下絵の透明度',
      elementOpacity: '部材の透明度'
    },
    viewSettings: {
      title: '3D 表示の設定',
      daylight: '日照',
      daylightSlider: '日照の時刻',
      presets: {
        morning: '朝',
        midday: '昼',
        evening: '夕方',
        night: '夜'
      },
      ceilingHeight: '天井高',
      sectionCut: '断面',
      sectionCutHint: '断面の高さより上は表示しません。'
    },
    editorToolGroups: {
      draw: '部屋/壁',
      openings: 'ドア/窓',
      structure: '構造',
      furnishings: '家具'
    },
    editorToolPanels: {
      drawHouse: '間取り',
      layout: '家具・材質'
    },
    camera: {
      tool: "カメラ",
      renderTool: "レンダリング",
      renderTitle: "レンダリング",
      renderRecaptureHint: "いまのカメラの位置で撮り直します",
      previewTitle: "カメラ {index} · 3D 表示",
      openComposition: "構図を調整",
      previewHint: "クリックで構図を調整",
      placingHint: "平面図をクリックしてカメラを配置してください",
      addOverhead: "3D 俯瞰",
      addOverheadHint: "建物を上から見下ろすカメラを追加します",
      overheadBadge: "俯瞰",
      overheadHint: "選んだ階を上から見下ろすカメラです。",
      compositionFromPreview: "構図は右上の 3D 表示で調整します。",
      place: "カメラを配置",
      panelTitle: "カメラ",
      empty: "カメラがありません。平面図に配置してください",
      limitReached: "カメラは最大 {max} 台",
      item: "カメラ {index}",
      position: "位置",
      elevation: "高さ",
      yaw: "向き",
      pitch: "仰角",
      fov: "画角",
      remove: "カメラを削除",
      enterComposition: "3D 構図へ",
      clampedTo: "{value} に制限しました",
      readonlyHint: "読み取り専用プロジェクトのためカメラを編集できません",
      lockedWhileRendering: "生成中はカメラを編集できません",
      compositionTitle: "3D 構図 · カメラ {index}",
      compositionDone: "完了",
      compositionCancel: "キャンセル",
      compositionHint: "ドラッグで視点回転、ホイールでズーム。枠内がそのまま出力範囲です。",
      compositionAspect: "16:9（出力比率と一致）",
      compositionDegraded: "ウィンドウが小さいため、構図枠を縮小表示しています",
      batchEntry: "一括レンダリング",
      batchViewResults: "生成結果を見る",
      batchFromCameras: "{count} 台のカメラで生成",
      batchTitle: "一括レンダリング",
      batchNew: "新規作成",
      batchHistoryEmpty: "生成履歴はありません。右のカメラパネルから生成を開始してください",
      batchFailedUnknown: "生成に失敗しました。原因は取得できません。再試行してください",
      batchFailedTimeout: "生成がタイムアウトしました。再試行してください",
      batchCaptureBusy: "前回の撮影が完了していません。しばらくお待ちください",
      batchPreviousResult: "前回の結果",
      batchCameraNoResult: "まだ生成結果はありません",
      batchCameraRemoved: "削除済みのカメラ（結果は保持）",
      batchRowSatisfied: "充足済み・今回は生成なし",
      batchStepConfig: "設定",
      batchStepCapture: "構図確認",
      batchCaptureConfirm: "各カメラの構図をご確認ください。必要に応じて撮り直せます",
      batchCaptureZoom: "クリックで拡大",
      batchRecapture: "撮り直す",
      batchCaptureNext: "{count} 枚で設定へ進む",
      batchCaptureAllFailed: "すべての撮影に失敗しました。カメラ位置を調整して再試行してください",
      batchStepRender: "生成",
      batchTarget: "カメラごとの目標枚数",
      batchStyle: "スタイル",
      batchStylized: "画風",
      batchResolution: "解像度",
      batchPromptPlaceholder: "追加のご要望（任意）",
      batchStartFailed: "生成を開始できませんでした。しばらくしてから再試行してください",
      batchGenerate: "不足分 {count} 枚を生成",
      batchAllSatisfied: "すべてのカメラが充足済みです",
      batchNoCameras: "先に平面図へカメラを配置してください",
      batchAdopt: "採用",
      batchAdopted: "採用 {n}/{k}",
      batchSatisfied: "充足 {k}/{k}",
      batchStale: "カメラ {index} の位置が変更されました。以前採用した {n} 枚は計上されません",
      batchCapturing: "キャプチャ中 {i}/{n}",
      batchSubmitting: "送信中 {i}/{n} — ページを離れないでください",
      batchQueued: "待機中",
      batchPendingCapture: "撮影待ち",
      batchCaptured: "撮影済み・未送信",
      batchRunning: "生成中",
      batchDone: "完了",
      batchFailed: "失敗",
      batchRetry: "再試行",
      batchSkip: "スキップ",
      batchUnsupported: "バックエンドは一度に {n} 枚の生成に未対応です。api サービスを更新してください",
      batchInvalid: "無効",
      batchClose: "閉じる",
    },
    editorToolSections: {
      stair: '階段',
      accessory: '小物',
      material: '素材',
      furniture: '家具',
      lighting: '照明',
      builtin: '造作',
      appliance: '家電',
      equipment: '設備'
    },
    editorToolCategories: {
      stairStairs: '階段',
      accessoryClocks: '時計',
      accessoryMirrors: 'ミラー',
      accessoryCushions: 'クッション',
      accessoryArt: 'アート・ウォールデコ',
      accessoryPlants: '観葉植物',
      accessoryOther: 'その他',
      furnitureDiningTables: 'ダイニングテーブル',
      furnitureDesks: 'デスク',
      furnitureDoubleBeds: 'ダブルベッド',
      furnitureSingleBeds: 'シングルベッド',
      furnitureRugs: 'ラグ',
      furnitureOther: 'その他',
      lightingPendant: 'ペンダントライト',
      lightingDown: 'ダウンライト',
      lightingSpot: 'スポットライト',
      lightingStand: 'スタンドライト',
      lightingBracket: 'ブラケットライト',
      lightingOther: 'その他',
      builtinCounter: 'カウンター',
      builtinShelf: '棚',
      builtinPillowShelf: '枕棚',
      builtinStorage: '収納',
      builtinEntranceStorage: '玄関収納',
      builtinOther: 'その他',
      applianceRefrigerator: '冷蔵庫',
      applianceTv: 'テレビ',
      applianceWasher: '洗濯機',
      applianceDryer: '乾燥機',
      applianceMicrowave: '電子レンジ',
      applianceVacuum: '掃除機',
      applianceOther: 'その他',
      equipmentKitchen: 'キッチン',
      equipmentCupboard: 'カップボード',
      equipmentToilet: '便器',
      equipmentWashbasin: '洗面台',
      equipmentBathtub: '浴槽',
      equipmentWasher: '洗濯機',
      equipmentWaterHeater: '給湯器',
      equipmentAirConditioner: 'エアコン',
      equipmentSwitch: 'スイッチ',
      equipmentOther: 'その他',
      furnitureKitchen: 'キッチン',
      furnitureToilet: 'トイレ',
      furnitureBathroom: '浴室',
      furnitureWashbasins: '洗面化粧台',
      furnitureAppliances: '家電',
      furnitureAirConditioning: '空調設備',
      furnitureWaterHeating: '給湯設備',
      walls: '壁',
      doorWindow: 'ドア・窓',
      holes: '開口',
      structure: '構造',
      stairs: '階段',
      furniture: '家具',
      kitchenBath: 'キッチン・水回り',
      furnitureSofa: 'ソファ',
      furnitureTables: 'テーブル・デスク',
      furnitureChairs: 'チェア・スツール',
      furnitureTableSets: 'テーブルセット',
      furnitureBeds: 'ベッド',
      furnitureCabinets: '収納',
      furnitureStorage: '収納',
      furnitureLighting: '照明',
      furnitureCushions: 'クッション',
      furnitureClocks: '時計',
      furnitureArtDecor: 'アート・装飾',
      furnitureMirrors: 'ミラー',
      materialWallpaper: '壁材',
      materialFlooring: '床材',
      other: 'その他',
      kitchenBathCabinet: 'キャビネット',
      kitchenBathKitchen: 'キッチン',
      kitchenBathEquipment: '設備',
      kitchenBathVanity: '洗面台',
      kitchenBathSanitary: '衛生器具'
    },
    editorToolRequired: {
      wall: '壁',
      area: '部屋エリア',
      door: 'ドア',
      doorDouble: '両開きドア',
      slidingDoor: '引き戸',
      window: '窓',
      sashWindow: '上げ下げ窓',
      gate: 'ゲート',
      floorOpening: '床開口',
      column: '柱',
      columnSquare: '角柱',
      beam: '梁',
      simpleStair: '簡易階段',
      sofa: 'ソファ',
      tables: 'テーブル・ローテーブル',
      chairs: '椅子・ベンチ',
      tableSets: 'テーブルセット',
      beds: 'ベッド・組み合わせベッド',
      cabinets: '収納・棚',
      kitchenCabinet: 'キッチン収納',
      kitchen: 'キッチン',
      equipment: '設備',
      bathroomVanity: '洗面化粧台',
      sanitary: '衛生器具'
    },
    editorToolUnavailable: '未提供',
    editorProperty: {
      emptyTitle: '未選択',
      emptyHint: '壁・建具・家具などを選ぶと、ここで編集できます。'
    },
    wallSurfaceMaterial: {
      title: '壁面マテリアル',
      currentSide: '壁面マテリアル · {side}',
      sideA: 'A · 壁方向の左側',
      sideB: 'B · 壁方向の右側',
      heading: '壁材質',
      sideAShort: 'A面',
      sideBShort: 'B面',
      sideGroup: '壁面側',
      texture: 'テクスチャ',
      color: '色',
      source: 'ソース',
      clearSide: 'この側の上書きを解除',
      sources: { surface: '側面の上書き', legacy: '壁プロパティ', theme: 'テーマ既定値' },
      textures: { bricks: 'レンガ', painted: '塗装壁' }
    },
    property: {
      clampedTo: '数値を範囲 {min}-{max} に調整しました。適用値は {actual} です',
      fittedToWall: '壁に収まるように {actual} にしました'
    },
    editorBottom: {
      otherFloorOpacity: '他階の透明度',
      showOtherFloors: '他階を表示',
      hideOtherFloors: '他階を非表示',
      expand3d: '拡大',
      previewInCanvas: '3Dプレビューは中央キャンバスに表示中',
      statistics: 'データ集計'
    },
    aiRoomDesign: {
      title: 'AI 部屋設計',
      open: 'AI 部屋',
      selectedProduct: '選択中の商品',
      noProduct: '商品が未選択です',
      selectProduct: '商品を選ぶ',
      browseProducts: '商品を見る',
      layerCount: '階数',
      livingRoom: '居間',
      diningRoom: 'ダイニング',
      masterRoom: '主寝室',
      secondRoom: '副寝室/書斎',
      kitchen: 'キッチン',
      bathroom: '浴室',
      storage: '収納室',
      staircase: '階段',
      notice1: 'AI はこの要件を参照しますが、最終的な部屋構成はアルゴリズムによって決定されます',
      notice2: '生成されたレイアウトは 455mm モジュールグリッドに整列され、既存のドアや窓は削除されます',
      elapsed: '経過時間',
      submit: '部屋レイアウトを生成',
      needAtLeastOneRoom: '少なくとも 1 つの部屋が必要です',
      successTitle: '部屋レイアウトの生成に成功しました'
    },
    aiWindowDesign: {
      title: 'AI ドア・窓設計',
      open: 'AI ドア・窓',
      roomCount: '現在の部屋数',
      notice: 'すべての壁にドアと窓を生成します。既存のドアと窓は置き換えられます',
      elapsed: '経過時間',
      submit: 'ドアと窓を生成',
      successTitle: 'ドアと窓の生成に成功しました',
      successMessage: '{doorCount} 個のドアと {windowCount} 個の窓を生成しました'
    },
    aiCandidatePreview: {
      previewTitle: 'AI デザインプレビュー',
      currentScene: '現在のデザイン',
      candidateScene: 'AI 候補デザイン',
      previewHint: '両方のデザインを比較して、適用する場合は確認してください',
      floorLabel: '階',
      outlineDiffsTitle: '輪郭の違い',
      layer: '階',
      beforeSize: '元のサイズ',
      afterSize: 'AI サイズ',
      sizeChange: 'サイズ変更',
      areaCoverage: 'カバー面積',
      areaChange: '面積変更',
      applyRoomLabel: 'AI 部屋設計を適用',
      applyWindowLabel: 'AI ドア・窓設計を適用'
    },
    reportCapture: {
      title: 'レポート画像の確認',
      stepFloors: '2D 間取り',
      stepViews: '3D ビュー',
      floorsHint: '各階の間取り画像を確認してください。内容に合わせて自動撮影します。',
      viewsHint: '3D ビューの画像を確認してください。現在の視点を主画像として使用します。',
      noFloors: '対象の階がありません。',
      noContent: 'この階には表示できる内容がありません。',
      viewIdle: 'まだ撮影していません。',
      recapture: '撮り直し',
      capture: '撮影',
      reframe: '範囲を選択',
      reframeCancel: '選択を終了',
      reframeHint: 'プレビュー上をドラッグして撮影範囲を選択してください。',
      zoomIn: '拡大',
      zoomOut: '縮小',
      confirm: '確認',
      delete: '削除',
      next: '次へ：3D ビュー',
      done: '確定',
      cancel: 'キャンセル',
      confirmIncomplete: '完了する前に、すべての階平面図と 5 枚の 3D レポート画像を確認してください。',
      mainBadge: '主画像',
      captureFailed: 'スクリーンショットの取得に失敗しました。',
      statusIdle: '未撮影',
      statusCapturing: '撮影中...',
      statusReady: '確認待ち',
      statusConfirmed: '確認済み',
      statusError: 'エラー',
      summary: '確認済み：階 {floors}/{floorTotal} · 3D {views} 枚',
      storageTrimmed: 'ローカル保存容量のため、余分な 3D ビュー画像を {count} 枚削減しました。',
      viewNames: {
        main: '主視点',
        current: '現在の視点',
        front: '正面',
        back: '背面',
        left: '左側',
        right: '右側'
      }
    },
    reportAssetsMissing: {
      title: 'レポート画像が未確認です',
      message: 'このプロジェクトでは間取り図と 3D レポート画像がまだ確認されていません。画像を確認するか、システムが自動生成するデフォルト資産でエクスポートを続行できます。',
      confirmImages: '画像を確認する',
      useDefault: 'デフォルト資産でエクスポートを続行',
      cancel: 'キャンセル'
    },
    reportAssetDefault: {
      generateFailed: 'デフォルトレポート資産の生成に失敗しました。しばらくしてから再試行してください。',
      retry: '再試行',
      missingFloorPlan: '間取り図が不足しています',
      missing3dView: '3D レポート画像が不足しています',
      captureFailed: 'スクリーンショットの取得に失敗しました'
    },
    shareLink: {
      title: '共有リンク',
      generating: '共有リンクを生成しています...',
      mockNotice: 'このリンクはデモ用です。正式な共有機能はバックエンド API 連携後に有効になります。',
      copy: 'リンクをコピー',
      copied: 'コピーしました',
      copyFailed: 'コピーに失敗しました。手動でコピーしてください。',
      error: '共有リンクの生成に失敗しました',
      retry: '再試行',
      close: '閉じる'
    },
    roomAreas: {
      dirtyHint: '部屋区域が変更された可能性があります。「部屋区域を再認識」をクリックして面積を更新してください。',
      recompute: '部屋区域を再認識',
      recomputeSuccess: '部屋区域を再認識しました',
      recomputeFailed: '部屋区域の認識に失敗しました。既存区域を保持しています',
      recomputeHistory: '部屋区域を再認識',
      metricsSummary: '部屋 {roomCount} · 総面積 {totalAreaM2} m² · 寝室 {bedroomCount}'
    },
    exportPdf: {
      success: 'PDF のダウンロードを開始しました',
      failed: 'PDF のエクスポートに失敗しました',
      mockNotice: '現在は mock サンプル PDF です。正式レポートは二段階のバックエンド排版後に提供されます。',
      capturePartial: '一部のスクリーンショット取得に失敗しましたが、エクスポートは続行します（編集には影響しません）。'
    },
    exportHtml: {
      success: 'HTML レポートをエクスポートし、新しいタブでプレビューしました',
      failed: 'HTML のエクスポートに失敗しました',
      mockNotice: '現在は静的 mock HTML です。正式ホスティングは二段階で提供されます。',
      capturePartial: '一部のスクリーンショット取得に失敗しましたが、エクスポートは続行します（編集には影響しません）。'
    },
    deleteSelected: '選択を削除',
    applyToSelection: '選択に適用',
    moveSelected: '選択を移動',
    moveToFloor: '階に移動',
    visible: '表示',
    unchanged: '変更なし',
    warnings: '警告',
    errors: 'エラー',
    aiSubmitting: 'AI タスクを送信中...',
    aiProcessing: 'AI 処理中 · {seconds} 秒 · ポーリング {attempt}',
    aiTodo: 'TODO：AI サービス連携は意図的に無効化されています。',
    featureDeveloping: '機能は開発中です',
    savedLocally: '保存しました。',
    saveFailed: '現在の変更は保存されませんでした。',
    draftRestored: '未保存の編集ドラフトを復元しました。',
    versionRestored: 'ローカルバージョンを復元しました。',
    projectLoaded: 'プロジェクトを読み込みました。',
    invalidProjectJson: 'プロジェクト JSON が無効です。',
    importDialogTitle: 'ローカル JSON を読み込む',
    importAsNewHint: '新規プロジェクトとして読み込みます。現在のプロジェクトには影響しません。',
    importStructureDecodeFailed: '構造データを解析できなかったため、建築部分のみを読み込みました。',
    importName: 'プロジェクト名',
    importBudget: '予算（万円）',
    importFrontage: '間口（間）',
    importConfirm: '新規プロジェクトとして読み込む',
    importRequiredFields: 'プロジェクト名・予算・間口を入力してから読み込んでください。',
    importedAsNewProject: '新規プロジェクトとして読み込みました。',
    groups: 'グループ',
    floors: '階',
    opacity: '不透明度',
    currentFloor: '現在の階',
    floorProperties: '階のプロパティ',
    basicParams: '基本パラメータ',
    layoutOpacity: '表示パラメータ',
    deleteFloor: '階を削除',
    deleteCurrentFloor: '現在の階を削除',
    deleteFloorConfirmMessage: '階を削除すると、その階のすべての設計内容が削除されます。続行しますか？',
    guides: 'ガイド',
    newGroup: '新規グループ',
    addSelected: '選択を追加',
    groupName: 'グループ名',
    rotate: '回転',
    duplicate: '複製',
    ungroup: 'グループ解除',
    deleteAll: 'すべて削除',
    removeFromGroup: 'グループから削除',
    addFloor: '階を追加',
    addUpperFloor: '上階を追加',
    addLowerFloor: '下階を追加',
    deleteFloorButton: '現在の階を削除',
    floorInsertPosition: '生成位置',
    floorPositionAbove: '上層（現在階の上）',
    floorPositionBelow: '下層（現在階の下）',
    floorName: '階名称',
    copyStructure: '現在の階の間取り構造を複製',
    confirm: '確認',
    duplicateFloor: '階を複製',
    selectAllFloor: 'すべて',
    selectAllFloorElements: '階の要素をすべて選択',
    lock: 'ロック',
    altitude: '高度',
    floorHeight: '階高',
    slabThickness: '床スラブ厚',
    moveUp: '上へ',
    moveDown: '下へ',
    addSelectedElement: '選択要素を追加',
    noVersions: '手動保存バージョンはまだありません。',
    restore: '復元',
    localVersions: 'ローカルバージョン',
    sceneWidth: 'シーン幅 ({unit})',
    sceneHeight: 'シーン高さ ({unit})',
    name: '名前',
    description: '説明',
    unit: '単位',
    familySize: '家族人数',
    style: 'スタイル',
    budget: '予算',
    daylightPriority: '採光優先',
    notes: 'メモ',
    roomRequirements: '部屋の要件',
    roomRelationships: '部屋の関係',
    fromRoom: '開始部屋',
    toRoom: '終了部屋',
    add: '追加',
    aiServiceTodo: 'TODO: AI サービス',
    rooms: {
      living_room: 'リビング',
      bedroom: '寝室',
      kitchen: 'キッチン',
      bathroom: '浴室',
      dining_room: 'ダイニング'
    },
    styles: {
      modern: 'モダン',
      minimal: 'ミニマル',
      classic: 'クラシック',
      industrial: 'インダストリアル'
    },
    budgets: {
      economy: 'エコノミー',
      standard: 'スタンダード',
      premium: 'プレミアム'
    },
    roomStatistics: {
      title: '部屋データ集計',
      scope: '範囲',
      allFloors: '全階',
      unnamedOrUnrecognized: '未命名・未識別',
      roomType: '部屋タイプ',
      roomCount: '数量',
      totalRooms: '総部屋数',
      totalArea: '総面積',
      calculating: '計算中',
      refreshing: '更新中',
      stale: '最新でない可能性があります',
      recompute: '再計算する',
       noData: '利用可能なデータがありません'
     },
     aiStructure: {
       entry: 'AI構造生成',
       modes: {
         label: '表示モード',
         architecture: '建築',
         structure: '構造'
       },
       overlay: {
         showBuilding: '建築を表示',
         hideBuilding: '建築を非表示',
         opacity: '建築の透明度'
       },
       plans: {
         label: '構造平面図',
         foundation: '一階床伏図',
         'beam-column': '{floor}小屋伏図',
         'bearing-wall': '{floor}耐力壁配置図'
       },
       lineModes: {
         label: '描画モード',
         line: '線',
         fixedWidth: '固定幅線',
         cappedLine: '端部付き線'
       },
       messages: {
         readOnly: 'この表示モードは読み取り専用です。',
         applied: '構造案を適用しました。'
       },
       errors: {
         system: '構造データを取得できませんでした。もう一度お試しください。',
         unavailable: '構造データを利用できません。もう一度生成してください。',
         readOnly: 'この表示モードは読み取り専用です。'
       },
       properties: {
         title: '構造要素の属性',
         empty: '構造要素を選択すると、読み取り専用の属性が表示されます。',
         layer: '階',
         type: '種類',
         role: '役割',
         section: '断面',
         elevation: '標高',
         hostWall: 'ホスト壁',
         wallSpecification: '壁仕様'
       }
     },
     mechanicsCheck: {
       historyUnlinked: "過去のチェックには構造との関連情報がありません。再度チェックを実行してください。",
       runningPrevious: "新しいチェックを実行中です。前回完了した結果を表示しています。",
       latestFailedPrevious: "最新のチェックに失敗しました。前回完了した結果を表示しています。",
       recoveryFailed: "クラウドのチェック結果を読み込めませんでした。再読み込みしてください。",
       recoveryUnlinked: "構造のタスクとの関連を確認できません。構造を再生成してからチェックしてください。",
       showFailures: '不合格部材を表示',
       hideFailures: '表示を解除',
       detailTitle: '部材の不合格詳細',
       detailEmpty: 'チェック結果に詳細情報がありません。',
       entry: '構造力学チェック',
       requiresStructure: '先に AI 構造生成を完了してください。',
       started: '構造力学チェックを開始しました。',
       completed: '構造力学チェックが完了しました。',
       failed: '構造力学チェックに失敗しました。もう一度お試しください。',
       resultTitle: '力学チェック結果',
       resultLoading: '構造力学チェックを実行しています…',
       resultPreparing: '力学チェック結果を読み込んでいます…',
       resultPreparingDescription: '計算は完了しました。結果ファイルを読み込んでいます。',
       resultEmpty: '構造力学チェックはまだ実行されていません。',
       statusDescription: 'チェック結果を待っています。現在の構造は引き続き表示されます。'
     }
   },
  designEvaluation: {
    entry: '設計評価',
    dialogTitle: '設計評価',
    planPreviewLabel: '平面図',
    previewLoading: '平面図を生成しています',
    previewFailed: 'この階の平面図を生成できませんでした',
    retryPreview: '再試行',
    designNotReady: '先にAI設計を完了してください',
    backendUnavailable: '評価機能は現在利用できません',
    scoreLabel: '評価',
    scoreRequired: '1〜10 点を選択してください',
    scoreAriaHint: '評価 1 から 10',
    commentLabel: 'コメント',
    commentPlaceholder: '評価を入力',
    commentCounter: '{count} / 1000',
    submissionNotice: '平面図は確認用です。送信内容は設計ID・評価点・コメントのみです',
    submit: '送信',
    cancel: 'キャンセル',
    submitting: '送信中',
    successMsg: '評価を記録しました',
    errorScore: '評価点が無効です。1〜10 の整数を選択してください',
    errorCommentTooLong: 'コメントが 1000 文字を超えています',
    errorForbidden: 'このアカウントには評価権限がありません',
    errorNotFound: '設計が存在しないか、アクセスできません',
    errorNotReady: 'AI設計がまだ完了していません',
    errorRateLimited: '送信が多すぎます。しばらくしてから再試行してください',
    errorInternal: '送信に失敗しました。しばらくしてから再試行してください',
    errorGeneric: '送信に失敗しました'
  },
  floorplan: {
    categories: {
      lines: '壁',
      holes: 'ドア・窓',
      structure: '構造',
      furnishings: '家具',
      items: 'アイテム',
      areas: 'エリア'
    },
    elements: {
      wall: '壁',
      "door": "片開きドア",
      "door-double": "両開きドア",
      "door-parent-child": "親子ドア",
      "sliding-door": "引違い戸",
      "door-pocket": "引込み戸（壁内）",
      "door-surface-sliding": "片引き戸（壁外）",
      "door-folding": "折れ戸",
      "window": "引違い窓",
      "window-fixed": "FIX窓",
      "window-side-hung": "片開き窓",
      "window-casement": "縦すべり出し窓",
      "window-awning": "横すべり出し窓",
      split: '開口',
      sofa: 'ソファ',
      bed: 'ベッド',
      chair: '椅子',
      bench: 'ベンチ',
      'dining-table': 'ダイニングテーブル',
      'round-table': 'ラウンドテーブル',
      'low-table': 'ローテーブル',
      desk: 'デスク',
      'side-table': 'サイドテーブル',
      console: 'コンソール',
      shelf: 'シェルフ',
      cabinet: 'キャビネット',
      'clothes-rack': 'ハンガーラック',
      'tv-board': 'TVボード',
      refrigerator: '冷蔵庫',
      kitchen: 'キッチン',
      toilet: '便器',
      bathtub: '浴槽',
      washbasin: '洗面台',
      'washing-machine': '洗濯機',
      'shoe-cabinet': '下駄箱',
      stair: '階段',
      'sofa-B': 'ソファ B',
      'chair-A': '椅子 A',
      'chair-B': '椅子 B',
      column: '柱',
      beam: '梁',
      'floor-opening': '床開口',
      'ceiling-opening': '上部吹抜',
      'ceiling-drop': '下がり天井',
      'column-square': '角柱',
      'independent-column': '独立柱',
      'fridge-A': '冷蔵庫 A',
      'simple-stair': '直進階段',
      'stair-l': 'L字階段',
      'stair-u': 'U字階段',
      'stair-c': 'コの字階段',
      'tv-board-A': 'TVボード A',
      'tv-board-B': 'TVボード B',
      area: '部屋エリア'
    },
    attributes: {
      name: '名前',
      visible: '表示',
      x: 'X',
      y: 'Y',
      rotation: '角度',
      offset: '位置',
      catalogItemId: 'カタログ ID',
      modelId: 'モデル ID',
      textureId: 'テクスチャ ID',
      materialId: 'マテリアル ID',
      displayName: '表示名',
      computedAreaM2: '面積 (m²)',
      computedAreaTsubo: '面積 (坪)'
    },
    properties: {
      type: "形式",
      hinge: "吊元／戸先",
      swing: "開き方向",
      registeredSize: "登録寸法",
      foldingPanels: "扉の枚数",
      handleStyle: "ハンドル",
      finish: '仕上げ',
      beamDepth: '梁成',
      dropDepth: '下がり寸法',
      openingWidth: "開口幅",
      storageSide: "収納方向",
      mountSide: "取付面",
      pocketSlotSide: "収納溝側",

      size: '寸法',
      basicParams: '基本パラメータ',
      dimensionParams: '寸法',
      roomName: '部屋名',
      sizeVariant: 'サイズ',
      selectedMaterial: '選択中',
      searchMaterial: '名前で絞り込む',
      noMaterialMatch: '該当する材質がありません',
      manufacturer: 'ブランド',
      width: '幅',
      depth: '奥行き',
      height: '高さ',
      length: '長さ',
      thickness: '厚さ',
      floorDistance: '床からの距離',
      topHeight: '上端の高さ',
      lighting: '照明',
      lightOnEvening: '夕方以降に点灯する',
      floorElevation: '床の段差',
      elevation: '床からの高さ',
      color: '色',
      material: '材質',
      texture: 'テクスチャ',
      texturePreview: 'テクスチャプレビュー',
      rotation: '角度',
      offset: '位置',
      open: '開く',
      flip_orizzontal: '反転',
      position: '位置'
    },
    beamFinishes: {
      wood: '木（化粧梁）',
      wallpaper: '壁紙（梁型）'
    },
    handleStyles: {
      lever: "レバー",
      knob: "握り玉",
      pull: "取っ手",
      bar: "バー",
      recessed: "彫込引手",
      none: "なし"
    },
    fittingOptions: {
      panelCount: '{n} 枚',
      left: "左",
      right: "右",
      in: "内開き",
      out: "外開き",
      storageLeft: "左収納",
      storageRight: "右収納",
      mountIn: "内側",
      mountOut: "外側",
      slotIn: "内側",
      slotOut: "外側"
    },
    textures: {
      plain: '単色',
      default: '未設定',
      bricks: 'レンガ',
      painted: '塗装',
      wood: '木床',
      tile: 'タイル',
      tatami: '畳',
      concrete: 'コンクリート',
      none: 'なし'
    },
    materials: {
      fabric: '布地',
      wood: '木材',
      metal: '金属',
      glass: 'ガラス',
      plastic: 'プラスチック'
    }
  },
  errors: {
    sessionExpired: 'セッションの有効期限が切れました。再度ログインしてください。',
    requestFailed: 'リクエストに失敗しました',
    aiDesign: {
      VALIDATION_ERROR: '入力検証に失敗しました',
      NETWORK_ERROR: 'ネットワーク接続に失敗しました',
      TIMEOUT: 'サービスの実行がタイムアウトしました',
      REMOTE_SERVICE_ERROR: 'AI サービスがエラーを返しました',
      PARSE_ERROR: 'ダウンロードパッケージまたは JSON を解析できません',
      PARTITION_FAILED: '現在の壁のレイアウトでは完全な AI 入力を形成できません',
      OUTLINE_SHRUNK: '建築範囲が変更されました',
      AI_RESULT_INVALID: 'AI が無効な構造を返しました',
      AI_RESULT_STATS_MISMATCH: 'バックエンド統計が実際のドア・窓と一致しません',
      AI_ELEMENT_GEOMETRY_CHANGED: 'ドア・窓フェーズで壁または部屋が変更されました',
      AI_SOURCE_SCENE_CHANGED: '間取りが変更されました。候補は古くなっています',
      APPLY_FAILED: 'AI デザインの適用に失敗しました',
      UNKNOWN: '未知のエラー'
    }
  },
  reportStudio: {
    entry: '画像制作',
    back: 'エディターに戻る',
    save: '保存',
    saveSuccess: 'レポート素材を保存しました',
    saveFailed: 'レポート素材の保存に失敗しました。しばらくしてから再試行してください',
    saveStatusUnsaved: '未保存',
    saveStatusSaved: '保存済み',
    canvasPlaceholder: '{type} は未実装です',
    settingsPlaceholder: '設定パネル（未実装）',
    assetRailPlaceholder: '素材パネル（未実装）',
    types: {
      layout: '配置図',
      floorPlan: '平面配置図',
      render: '3D レンダリング',
      elevation: '立面図'
    },
    rail: {
      title: '保存済み素材',
      empty: 'このタイプの保存済み素材はありません',
      delete: '削除',
      confirmForReport: 'PDF/HTMLレポート用に確認',
      confirmedForReport: 'PDF/HTML用に確認済み',
      statusPreview: 'プレビュー未確認',
      statusMissing: '未入力/未確認',
      slots: {
        layout: '配置図',
        floorPlan: '階 {layer}',
        renderMain: 'メイン視点',
        renderSubTop: 'サブ（上）',
        renderSubBottom: 'サブ（下）',
        elevationFront: '正面',
        elevationBack: '背面',
        elevationLeft: '左側',
        elevationRight: '右側'
      }
    },
    render: {
      renderType: 'レンダリング種別',
      renderTypeScreenshot: '現在のスクリーンショット',
      aiRender: 'AI レンダリング',
      aiRenderPending: 'インターフェース接続待ち',
      cameraPresets: '視点プリセット',
      presets: {
        'oblique-front': '斜め前方',
        aerial: '俯瞰'
      },
      renderStyle: 'レンダリングスタイル',
      renderStylePlaceholder: '近日対応',
      aspectRatio: '画面比率',
      aspectRatioPlaceholder: '近日対応',
      saveCurrentView: '現在の視点を保存',
      saveAsMain: 'メインに保存',
      saveAsSubTop: 'サブ（上）に保存',
      saveAsSubBottom: 'サブ（下）に保存',
      resetCamera: '視点をリセット',
      captureFailed: '3D スクリーンショットに失敗しました'
    },
    elevation: {
      direction: '方向',
      directions: {
        front: '正面',
        back: '背面',
        left: '左側',
        right: '右側'
      },
      layoutMode: 'レイアウト',
      layoutModeSingle: '単一制作',
      layoutModeOverview: '4 面一覧',
      saveCurrentView: '正交視点を保存',
      saveDirection: '{direction} を保存',
      unsaved: '未保存',
      backToOverview: '4 面一覧に戻る',
      resetCamera: '視点をリセット',
      captureFailed: '3D スクリーンショットに失敗しました',
      generateSingleViewPreview: '単一視点のプレビューを生成'
    },
    confirm: {
      replaceTitle: '確認済み画像を差し替え',
      replaceMessage: 'この素材は PDF/HTML レポート用に確認済みです。新しい画像に差し替えますか？',
      deleteTitle: 'レポート素材を削除',
      deleteMessage: '削除するとレポートにこの素材が不足します。続行しますか？',
      noPreview: '左側で画像を生成または選択してください',
      confirmButton: '確認'
    },
    capture: {
      deprecatedGuard: 'このダイアログは本番エクスポート経路から外れました。レポート素材制作ページで確認してからエクスポートしてください。'
    },
    layout: {
      imageSource: '画像ソース',
      upload: '画像をアップロード',
      pickExisting: '既存画像から選択',
      pickEmpty: '選択できる画像がありません',
      fitMode: 'フィット方式',
      fitWidth: '幅に合わせる',
      fitHeight: '高さに合わせる',
      fitPage: 'ページに合わせる',
      saveLayout: '配置図を保存',
      noImageSelected: '画像をアップロードするか、既存画像から選択してください',
      canvasEmpty: '白紙プレビュー（画像未選択）',
      zoomIn: '拡大',
      zoomOut: '縮小',
      uploadFailed: '画像の読み込みに失敗しました',
      uploadInvalidType: '画像ファイルを選択してください'
    },
    floorPlan: {
      floorSwitch: '階切替',
      visibility: '表示オプション',
      showTotalDimensions: '外周総寸法',
      showSegmentDimensions: '上下左右分段寸法',
      showRoomNames: '部屋名',
      showRoomAreas: '部屋面積',
      showFurniture: '家具',
      showHoles: '建具',
      dimensionActions: '寸法操作',
      autoGenerate: '自動生成',
      addManual: '手動追加',
      cancelManualAdd: '追加をキャンセル',
      deleteSelected: '選択を削除',
      hideSelected: '選択を非表示',
      regenerateAll: 'すべて再生成',
      resetOffsets: 'オフセットをリセット',
      roomLabelActions: '部屋ラベル',
      toggleRoomLabels: 'ラベル表示切替',
      resetRoomLabelPositions: '位置をリセット',
      saveCurrentFloor: '現在の階をレポート素材として保存',
      captureFailed: '2D スクリーンショットに失敗しました',
      noChainSelected: '寸法チェーンを選択してください',
      manualAddHint: 'キャンバス上で 2 点を順にクリックしてください',
      manualAddInvalid: '水平/垂直寸法のみ対応しています',
      noDimensionBounds: '現在の階には寸法を生成できる輪郭がありません'
    }
  },
  reportExportConfirm: {
    title: {
      pdf: 'PDFレポートエクスポート確認',
      html: 'HTMLレポートエクスポート確認'
    },
    generatePdf: 'PDFレポートを生成',
    generateHtml: 'HTMLレポートを生成',
    optionalBadge: '任意',
    missingHint: '必須素材が {count} 件未入力または未確認です。補完後に生成してください。',
    optionalMissingHint: '配置図は任意項目です。未入力でもレポート生成に影響しません。',
    openStudioHint: 'クリックして制作ページで確認',
    statusConfirmed: '確認済み',
    statusPreview: '未確認',
    statusMissing: '未入力/未確認'
  },
  // P06: 异步 AI 设计 UI 文案（供 P01–P05/P07 对齐；勿与 errors.aiDesign 混淆）
  aiDesign: {
    fields: {
      productType: 'ProductType（プロジェクト名）',
      totalArea: 'TotalArea（坪）',
      layers: 'Layers（階数）',
      widthKen: 'WidthKen（間口）',
      unitPrice: '坪単価',
      unitPriceValue: '{count} 万円/坪',
      totalAreaValue: '{count} 坪',
      budget: '予算',
      frontage: '間口',
      projectName: 'プロジェクト名',
      algorithm: 'アルゴリズム'
    },
    algorithms: {
      floorplan_diffusion: '拡散モデル',
      floorplan_gpt_image_2: 'VLM',
      floorplan_gpt6: 'LLM Agent',
      building_element_diffusion: '建具 Diffusion',
      building_element_rule: '建具ルール'
    },
    status: {
      queued: 'キュー待ち',
      generating: '生成中',
      completed: '完了',
      failed: '生成失敗',
      waitedTime: '待機時間 {seconds} 秒',
      canLeavePage: 'このページを離れても構いません'
    },
    actions: {
      abandonTask: 'タスクを放棄',
      abandonConfirm: 'タスク「{name}」を放棄しますか？結果は表示・適用されなくなります。',
      viewNewPlan: '新しいプランを見る',
      confirmReplace: '置き換えを確認',
      retrySameParams: '同じパラメータで再試行'
    },
    waiting: {
      editLocked: '生成期間は編集がロックされています。進捗はそのまま続き、このページを離れても構いません。',
    },
    messages: {
      floorplanChanged: '現在の間取りが変更されました',
      regenerateWindows: '建具を再生成してください',
      busy: 'サーバーが混み合っています。しばらくしてからもう一度お試しください。',
      taskRecordCorrupted: 'タスク記録が破損しています',
      resultInvalid: '結果が無効です'
    },
    projectCard: {
      generating: '生成中',
      completed: '完了',
      failed: '失敗'
    },
    validation: {
      budget: '予算は 500〜3500 万円の整数で入力してください',
      input: '入力内容が不正です',
      projectName: 'プロジェクト名を入力してください',
      frontage: '間口は 2〜5 間（0.5 刻み）で選択してください',
      layers: '階数は 1〜3 で選択してください',
      algorithm: '選択したアルゴリズムはこの設計タイプでは利用できません'
    }
  },
  drawingVectorize: {
    editor: {
      loadFailed: '校正済み図面を読み込めませんでした。しばらくしてから再試行してください。',
      rescale: '縮尺',
      autosaveOn: '自動保存',
      autosaveSaving: '保存中…',
      autosaveSaved: '保存済み',
      autosaveFailed: '保存失敗',
      furnitureArriving: '家具を配置しています…',
      furnitureFailed: '家具の読み取りに失敗しました。部屋はそのまま編集できます',
      reupload: '再生成',
      reuploadConfirm: 'アップロード画面に戻ります。'
    },
    rescale: {
      title: '縮尺の変更',
      gridTitle: '小グリッド',
      gridHint: '壁を合わせるグリッドの寸法です。',
      warning: '縮尺を変えると、エディタでの変更は元に戻ります。',
      apply: 'この縮尺で作り直す',
      confirm: 'この縮尺で作り直しますか？',
      done: '縮尺を変更しました'
    },
    upload: {
      title: '図面から取り込む',
      handDrawnTitle: '手描き平面図をアップロード',
      subtitle: '平面図をアップロードすると、壁・建具・部屋を自動で読み取ります。図面に寸法があれば縮尺も自動で設定し、読み取れない場合は既知の壁の実寸を入力して確定します。',
      dropTitle: '図面アップロード',
      dropMain: '平面図をここにアップロードしてください',
      dropSub: '画像・PDF を直接ドラッグ＆ドロップするか、クリックしてファイルを選択',
      page: 'PDF ページ',
      pdfSelectTitle: '読み取るページを選んでください',
      pdfLoading: 'PDF のページを読み込んでいます…',
      pdfFailed: 'PDF のページを表示できませんでした。ページ番号で指定してください。',
      pdfPageLabel: '{page} ページ目',
      pdfPageCount: '全 {count} ページ',
      pdfTooManyPages: '先頭 {max} ページのみ表示しています。',
      accepted: '対応形式：PNG / JPEG / TIFF / PDF、5MB まで',
      tooLarge: 'ファイルが 5MB を超えています',
      start: '読み取りを開始',
      cancel: 'キャンセル',
      stopWaiting: '待機をやめる',
      retry: '再試行',
      detail: '詳細',
      projectName: 'プロジェクト名',
      apply: 'エディタで開く',
      reupload: '図面を差し替える',
      backToEditor: 'エディタに戻る',
      sourceTitle: 'アップロードした図面',
      sourceOpen: 'クリックで拡大',
      sourceClose: '閉じる',
      removeFile: 'アップロードした図面を削除',
      regionHint: '枠をドラッグして読み取り範囲を選べます。',
      regionReset: 'ページ全体に戻す',
      reading: '図面を読み込んでいます…',
      restoring: '前回の図面を読み込んでいます…',
      restoreFailed: '前回の図面を読み込めませんでした。もう一度アップロードしてください。',
      sourceNoPreview: 'PDF はこの場でプレビューできません。'
    },
    progress: {
      uploading: '図面をアップロードしています',
      queued: '順番待ちです',
      recognizing: '読み取り中',
      backgroundNotice: 'このページを閉じても読み取りは続きます。'
    },
    calibrate: {
      title: '縮尺の確定',
      badgeCalibrated: '確定済み',
      badgeUncalibrated: '未確定',
      assumedNotice: '正しい寸法を入力してください',
      pickPrompt: '図面上で実寸のわかる壁をクリックしてください。',
      wholeWall: '芯々寸法',
      wholeWallUnavailable: 'この線は元の壁を逆引きできないため、1 区間のみで測ります。',
      currentLength: '現在の長さ',
      currentLengthValue: '約 {mm} mm（{px} px）',
      inputPlaceholder: '実寸をミリメートルで',
      submit: '確定',
      submitting: '計算中…',
      result: '{mmPerPx} mm/px ／ 基準：{reference}',
      badgeAuto: '自動設定',
      badgeSuggested: '要確認',
      autoTitle: '図面の寸法から縮尺を自動で設定しました。',
      suggestedTitle: '図面の寸法から縮尺を推定しました。確定する前にご確認ください。',
      reasons: {
        single_orientation: '縦・横のうち一方向の寸法しか読み取れませんでした。',
        orientation_disagree: '縦方向と横方向の寸法から求めた縮尺が食い違っています。',
        no_long_baseline: '建物全体にわたる長い寸法が読み取れませんでした。',
        few_inliers: '互いに一致する寸法の本数が足りません。',
        low_agreement: '読み取った寸法どうしの食い違いが大きくなっています。'
      },
      extentValue: '建物の外形：約 {width} m × {height} m',
      acceptEstimate: 'この縮尺で確定',
      pickPromptOverride: '違う場合は、実寸のわかる壁を図面上でクリックして長さを入力してください。',
      overridden: '図面の寸法による自動設定（{mmPerPx} mm/px）から変更しています。',
      revertToEstimate: '自動設定に戻す',
      referenceDimensions: '図面の寸法'
    },
    quality: {
      title: '確認をおすすめする箇所',
      adjustment: '調整「{action}」：{count} 件',
      // 楼梯识别的调整记录。没有对应文案的动作码仍原样显示（见 WizardImportDrawingView）。
      actions: {
        area_relabelled_staircase: '階段が描かれていたため部屋を階段室に変更',
        stair_synthesized_from_area: '階段室に階段を自動配置（階段本体は未検出）',
        stair_form_inferred: '階段の形式を部屋の形から推定',
        stair_direction_inferred: '階段の上り方向を推定',
        stair_facing_conflicts_footprint: '上り方向が範囲と矛盾するため向きを変更',
        stair_form_conflicts_footprint: '階段の形式が範囲と矛盾するため部屋の形から推定',
        stair_area_not_rectangular: '階段室が長方形ではない',
        stair_footprint_fallback_to_preset: '部屋に合わないため標準寸法の階段を配置',
        stair_footprint_from_detection: '部屋の一角が欠けているため、階段の範囲を検出枠から取得（階段下収納の上に掛かる階段）',
        stair_footprint_from_room_label: '階段の範囲を部屋ラベルの枠から取得（検出枠が小さすぎたため）',
        stair_clamped_to_min_footprint: '部屋が小さいため最小寸法の階段を配置',
        stair_overflows_area: '階段が部屋からはみ出している',
        stair_without_area: 'どの部屋にも属さない階段',
        stair_dropped_at_placement: '配置できなかった階段',
        staircase_area_without_stair: '階段を置けない階段室（大きすぎる／小さすぎる）',
        staircase_label_ignored: 'UP / DN 表記だけの大きな部屋は階段室として扱わない',
        stair_opening_added: '階段の上り口の壁に開口を設けた（階段の向きから推定）',
        stair_opening_skipped_exterior: '階段の上り口が外壁に面しているため開口を設けていない（階段の向きを確認してください）',
        stair_opening_skipped_room: '階段の上り口が水回り・収納・寝室に面しているため開口を設けていない（階段の向きを確認してください）',
        stair_opening_skipped_narrow: '階段の上り口の壁が短く、開口を設けられない',
        stair_orientation_from_start: '階段の向きを動線の始点（UP / DN の起点）から補正',
        stair_direction_from_neighbour: '階段の向きを上り口の外側の部屋から推定',
        furniture_outside_building_dropped: '建物から離れた家具を除外（同じページの完成予想図などから誤って検出されたもの）',
        floor_level_from_drawing: '図面の床高さの表記（1FL-200、+300 など）から床の段差を設定',
        floor_level_assumed_from_name: 'スキップフロア・小上がりの床の高さを仮の値で設定（図面に高さの記載がないため、エディタで確認してください）',
        floor_boundaries_split_rooms: '床の段差・手すりの線（壁ではない）で部屋を区切りました',
        stair_room_carved: '階段がとなりの部屋と同じ区画になっていたため、階段を別の部屋に切り分けました',
        column_dropped: '独立柱として置かなかった候補（大きさが合わない、壁の中、家具の中）'
      },
      unmatchedRooms: '面に対応づけられなかった部屋：{names}',
      reviewRequired: '全体的に人手での確認をおすすめします。',
      adviceOnly: 'エディタで修正できます。'
    },
    errors: {
      DRAWING_VECTORIZE_BUSY: '読み取りサービスが混み合っています。約 {seconds} 秒後に再試行してください。',
      DRAWING_VECTORIZE_FAILED: '読み取りに失敗しました。時間をおいて再試行してください。',
      DRAWING_INPUT_UNSUPPORTED: '対応していないファイルです。PNG / JPEG / TIFF / PDF（5MB まで）を選んでください。',
      DRAWING_CALIBRATION_INVALID: '入力された長さでは縮尺を確定できません。別の壁か正しい実寸をお試しください。',
      DRAWING_SCENE_REJECTED: '読み取り結果をエディタに読み込めませんでした。',
      TIMEOUT: '時間内に応答がありませんでした。再試行してください。',
      NETWORK_ERROR: 'ネットワークに接続できません。',
      REMOTE_SERVICE_ERROR: 'サーバーがエラーを返しました。',
      VALIDATION_ERROR: '入力内容を確認してください。',
      STORAGE_WRITE_FAILED: '保存に失敗しました。',
      NAME_REQUIRED: 'プロジェクト名を入力してください。',
      NOT_CALIBRATED: '縮尺が未確定です。先に実寸を入力してください。',
      IMPORT_FAILED: 'プロジェクトの作成に失敗しました。',
      DRAWING_JOB_SUBMIT_FAILED: '読み取りジョブの送信に失敗しました。もう一度お試しください。',
      DRAWING_JOB_NOT_FOUND: 'この読み取りジョブが見つかりません。もう一度実行してください。',
      DRAWING_JOB_FAILED: '読み取りジョブが失敗しました。もう一度お試しください。',
      DRAWING_JOB_TIMEOUT: '読み取りの待機がタイムアウトしました。処理は続いている可能性があります。しばらくしてからお試しください。',
      DRAWING_RESULT_NOT_READY: '結果はまだ準備できていません。少々お待ちください。',
      UNKNOWN: '不明なエラーが発生しました。'
    }
  },
  el: elementLocale.el
}
